import {connect} from "react-redux";
import ValetAccountView from "./view";
import {bindActionCreators} from "redux";
import {accountById} from "../../../../service/Valet/action";
import {locationPinCode, locationCity, locationZone, locationArea, stateAndRegion} from "../../../../service/locations/action";
const mapStateToProps = (state) => ({
    accountByIdDetails:state.Valet.accountById,
    pincodeData: state.locationReducer.pincodeData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountById,
            locationPinCode
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetAccountView);
